module.exports = __webpack_public_path__ + "79e9b49eeb8356ec9ee932058267da1d.png";